import { FC, ReactNode, useState } from 'react';
import {
  getDragInfo,
  getDragError
} from 'Pages/ListagemArquivos/ListagemArquivos.helpers';
import styles from './FileDrop.module.scss';

export interface IFileDrop {
  children: ReactNode;
  dragInfo?: string;
  maxQtyUploadFiles?: number;
  limitUpload?: number;
  onDropFiles: (files: FileList) => void;
}

const FileDrop: FC<IFileDrop> = ({
  children,
  dragInfo,
  maxQtyUploadFiles,
  limitUpload,
  onDropFiles,
}) => {
  const [displayZone, setDisplayZone] = useState(false);
  const [dragDropInfo, setDragDropInfo] = useState(getDragInfo(dragInfo));

  const onDragOver = (ev: any) => {
    ev.preventDefault();
  };

  const onDragEnter = (ev: any) => {
    if (ev.dataTransfer.types.includes('Files')) {
      setDisplayZone(true);
    }
    if (maxQtyUploadFiles && (ev.dataTransfer.items.length > maxQtyUploadFiles)) {
      setDragDropInfo(getDragError(limitUpload))
    } else {
      setDragDropInfo(getDragInfo(dragInfo))
    }
  };

  const onDragLeave = (ev: any) => {
    setDisplayZone(false);
  };

  const onDrop = (ev: any) => {
    ev.preventDefault();
    setDisplayZone(false);
    onDropFiles(ev.dataTransfer.files);
  };

  return (
    <div
      className={styles['fileDropWrap']}
      onDragEnter={onDragEnter}>
      {children}
      <div
        className={styles['dragInfoWrap']}
        hidden={!displayZone}
        onDrop={onDrop}
        onDragLeave={onDragLeave}
        onDragOver={onDragOver}>
        {dragDropInfo}
      </div>
    </div>
  );
};

export default FileDrop;
